var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-row-index-loader animated fadeIn"},[_c('UIGradientLoader'),_c('UIGradientLoader'),_c('UIGradientLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }